import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XMarkIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';
import { Button } from '../ui/Button';

interface EarlyAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const EarlyAccessModal: React.FC<EarlyAccessModalProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
          />

          {/* Modal Content */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative bg-white dark:bg-gray-900 w-full max-w-md rounded-[2.5rem] shadow-2xl overflow-hidden border border-gray-100 dark:border-gray-800"
          >
            <button
              onClick={onClose}
              className="absolute top-6 right-6 p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-gray-400"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>

            <div className="p-8 sm:p-10 text-center">
              <div className="mx-auto w-20 h-20 bg-black dark:bg-white rounded-3xl flex items-center justify-center mb-8 shadow-xl transform -rotate-6">
                <RocketLaunchIcon className="h-10 w-10 text-white dark:text-black" />
              </div>

              <h3 className="text-3xl font-extrabold text-gray-900 dark:text-white mb-4 tracking-tight">
                We're almost ready for you! 🚀
              </h3>
              
              <div className="space-y-4 text-gray-600 dark:text-gray-400 text-lg leading-relaxed mb-10">
                <p>
                  Thank you for your interest in ClickCollab. We are currently in exclusive early access to ensure the best experience for our community.
                </p>
                <p className="font-semibold text-black dark:text-white">
                  We've added your email to our priority waitlist and will reach out personally once we're ready for you to join!
                </p>
              </div>

              <Button
                onClick={onClose}
                size="lg"
                className="w-full bg-black dark:bg-white text-white dark:text-black font-bold py-4 rounded-2xl hover:scale-[1.02] transition-transform shadow-lg"
              >
                Got it, thanks!
              </Button>
            </div>
            
            {/* Aesthetic bottom bar */}
            <div className="h-2 bg-gradient-to-r from-purple-500 via-blue-500 to-indigo-500 w-full" />
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default EarlyAccessModal;
